import { memo } from "react";
import AndarTitleImg from "../../../../../../assets/games/AB_classic_Non_timer/AndarTitle.svg"
import BaharTitleImg from "../../../../../../assets/games/AB_classic_Non_timer/BaharTitle.svg"
import closeIcon_img from "../../../../../../assets/games/AB_classic_Non_timer/x.svg"

const AndarBaharClassicNonTimerInfo = memo((props) => {

    return <div className="ABC_NT_info_popup_back">
        <div className="ABC_NT_info_popup">
            <img className="ABC_NT_Info_close" onClick={()=>{props.closePopup()}} src={closeIcon_img} alt="closeIcon" />
            <div className="infoPopUpTitle">
                <img className="ABC_NT_info_title" src={AndarTitleImg} alt="Andar" />
                <img className="ABC_NT_info_title" src={BaharTitleImg} alt="Bahar" />
            </div>
            <div className="ABC_NT_INFO_DETAILS">
                <div className="ABC_NT_LIMITS_BOX">
                    <h2 className="ABC_NT_info_popUp_titles">Limits</h2>
                    <div className="ABC_NT_Limits">
                        <table className="ABC_NT_limits_table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Bet Type</th>
                                    <th>Limits</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="ABC_NT_LimitValues">1</td>
                                    <td className="ABC_NT_LimitValues">Rank Cards</td>
                                    <td className="ABC_NT_LimitValues">{props.innerLimits.split("|")[0]}</td>
                                </tr>
                                <tr>
                                    <td className="ABC_NT_LimitValues">2</td>
                                    <td className="ABC_NT_LimitValues">Suits</td>
                                    <td className="ABC_NT_LimitValues">{props.innerLimits.split("|")[1]}</td>
                                </tr>
                                <tr>
                                    <td className="ABC_NT_LimitValues">3</td>
                                    <td className="ABC_NT_LimitValues">A - 6/8 - K</td>
                                    <td className="ABC_NT_LimitValues">{props.innerLimits.split("|")[2]}</td>
                                </tr>
                                <tr>
                                    <td className="ABC_NT_LimitValues">4</td>
                                    <td className="ABC_NT_LimitValues">Andar/Bahar</td>
                                    <td className="ABC_NT_LimitValues">{props.innerLimits.split("|")[3]}</td>
                                </tr>
                                <tr>
                                    <td className="ABC_NT_LimitValues">5</td>
                                    <td className="ABC_NT_LimitValues">Minimum Bet</td>
                                    <td className="ABC_NT_LimitValues">{props.minBetAmt}</td>
                                </tr>
                                <tr>
                                    <td className="ABC_NT_LimitValues">6</td>
                                    <td className="ABC_NT_LimitValues">Maximum Bet</td>
                                    <td className="ABC_NT_LimitValues">{props.maxBetAmt}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <hr className="ABC_NT_INFO_HR" />
                <div className="ABC_NT_GameRules_BOX">
                    <h2 className="ABC_NT_info_popUp_titles">How To Play ?</h2>
                    <div className="ABC_NT_gameRules">
                        <p>Andar Bahar Non-Timer is a classic Indian card game that combines both skill and luck. It is a variant of the standard Andar Bahar game, played with a single deck of 52 playing cards. Unlike the timed version, this version allows players to place their bets without the pressure of a countdown, offering a more relaxed and strategic gaming experience. The game involves two primary types of bets — Rank Cards, Suit Bets, A-6 and 8-K Bets, and bets on the Andar or Bahar position.</p>
                        <ol>
                            <li><b>Initial Bet Placement:</b>
                                <ul>
                                    <li>
                                        Players begin by placing their bets on <b>Rank Cards</b>, <b>Suit Bets</b>, or <b>A-6 and 8-K Bets</b>.
                                        <ul>
                                            <li><b>Rank Cards:</b> A player can wager on the likelihood of certain card ranks (such as Ace, King, Queen, etc.) appearing in either the Andar or Bahar positions.</li>
                                            <li><b>Suit Bets:</b> Players can bet on the suit (Hearts, Diamonds, Clubs, or Spades) that the Joker Card will belong to.</li>
                                            <li><b>A-6 and 8-K Bets:</b> A wager on whether the Joker Card will fall within the <b>A-6 range</b> (Ace through 6) or the <b>8-K range</b> (8 through King).</li>
                                        </ul>
                                    </li>
                                    <li>After the initial bets are placed, the <b>Joker Card</b> is revealed. The Joker Card is drawn from the deck and serves as a reference point for the rest of the game.</li>
                                </ul>
                            </li>
                            <li>
                                <b>Bet on Andar or Bahar:</b>
                                <ul>
                                    <li>Once the Joker Card is revealed, players can now place their bet on either the <b>Andar</b> (left side) or <b>Bahar</b> (right side) position. The decision is based on which side (Andar or Bahar) will match the <b>Joker Card's rank</b> first.
                                        <ul>
                                            <li>The <b>Andar</b> position represents the left-hand side, while the <b>Bahar</b> position represents the right-hand side of the playing area.</li>
                                            <li>Players can place their bets on one side (Andar or Bahar) before card dealing begins.</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <b>Card Dealing:</b>
                                <ul>
                                    <li>The dealer begins dealing cards alternately to the Andar and Bahar positions. Cards are dealt one at a time from the deck.</li>
                                    <li>The cards are dealt face-up, starting with the first card on <b>Andar</b>, then the next on <b>Bahar</b>, and so on.</li>
                                    <li>The objective is for the <b>Joker Card's rank</b> to match a card dealt to either Andar or Bahar.</li>
                                </ul>    
                            </li>
                            <li>
                                <b>Winning Condition:</b>
                                <ul>
                                    <li>The first side (Andar or Bahar) to receive a card that matches the <b>rank</b> of the <b>Joker Card</b> wins the round.</li>
                                    <li>For example, if the Joker Card reveals a <b>Queen</b>, the round ends when either the Andar or Bahar position receives a <b>Queen</b>.</li>
                                </ul>
                            </li>
                            <li>
                                <b>Payout Calculation:</b>
                                <ul>
                                    <li><b>Rank Bets:</b> If the rank bet on Andar or Bahar is correct, a payout is provided as per the <b>payout table</b>.</li>
                                    <li><b>Suit Bets:</b> If the suit of the Joker Card matches the bet placed on the suit, a payout is awarded.</li>
                                    <li><b>A-6 and 8-K Bets:</b> If the Joker Card falls within the chosen range (A-6 or 8-K), the player receives a payout.</li>
                                    <li><b>Andar/Bahar Bets:</b> If a player's chosen position (Andar or Bahar) matches the Joker Card’s rank, they win the round and are paid according to the payout table.</li>
                                </ul>
                            </li>
                        </ol>
                    </div>
                </div>
                <hr className="ABC_NT_INFO_HR" />
                <div className="ABC_NT_Payout_BOX">
                    <h2 className="ABC_NT_info_popUp_titles">Payout Table</h2>
                    <table className="ABC_NT_payoutTable">
                        <thead>
                            <th>Win Combination</th>
                            <th>Prize</th>
                        </thead>
                        <tbody>
                            {props.payoutInfo.map((ele) => <tr key={JSON.stringify(ele)}>
                                <td>{ele.key}</td>
                                <td>{ele.value}</td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
})

export default AndarBaharClassicNonTimerInfo